<template>
  <div
    v-if="shouldDisplay"
    class="confirm-iframe"
  >
    <div
      v-if="isAuxIFrameDisplayed"
      :id="frameID"
      class="hidden"
    />
    <div :id="frameIDLoaded" />
  </div>
</template>

<script lang="ts">
import { ConfirmIframePathBuilder } from '~/core/ts/legacy/helpers/ConfirmIFramePathBuilder'
import { DocumentScriptLoader } from '~/core/ts/legacy/helpers/DocumentScriptLoader'

import type { Spa } from '~/core/ts/entity/Spa'
import LoadingEventBus from '~/core/events/loading'

import { useLangSelector } from '~/core/composable/shared/useLangSelector'

type WindowWithPlugins = Window & typeof globalThis & { UTBInsertSpaBooking?: any; jQuery: any };

export default defineNuxtComponent({
  props: {
    spa: {
      type: Object as PropType<Spa>,
      required: true,
    },
  },
  setup(props) {
    const frameID = 'utb-iframe-spa'
    const frameIDLoaded = 'utb-iframe-spa-loaded'

    const shouldDisplay = ref(false)

    const isAuxIFrameDisplayed = ref(true)
    const utbPath = ref<string | null>(null)
    const route = useRoute()
    const router = useRouter()

    const runtimeConfig = useRuntimeConfig()

    const { currentLang } = useLangSelector()

    const iframePath = runtimeConfig.public.bookingIframePath || ''

    const insertSpaBooking = async ({
      iframeID,
      confirmIFrame,
    }: {
      iframeID: string;
      confirmIFrame: {
        brandID: string,
        spaUUID: string,
        utbPath: string,
        pin: string,
        langCode: string,
      };
    }) => {
      const windowWithPlugins = window as WindowWithPlugins

      const { base } = new ConfirmIframePathBuilder(confirmIFrame).build()

      new windowWithPlugins.UTBInsertSpaBooking({
        base,
        path: utbPath.value,
      }).insertIFrameAndPReset(iframeID)
    }

    const tryToLoadIFrame = () => {
      new DocumentScriptLoader(document).load({
        url: iframePath,
        onLoad: async () => {
          const utbPath = decodeURI(`${route.query.utb_path}`)
          const pin = `${route.query.utb_d3226782744ce122d789ea8e03d32f53}`

          await insertSpaBooking({
            iframeID: frameIDLoaded,
            confirmIFrame: {
              brandID: props.spa.brandId,
              spaUUID: props.spa.uuid,
              utbPath,
              pin,
              langCode: currentLang,
            },
          })

          isAuxIFrameDisplayed.value = (false)
          LoadingEventBus.hide()
        },
      })

      if (!(window as WindowWithPlugins).jQuery) {
        setTimeout(tryToLoadIFrame, 1000)
        LoadingEventBus.show()
      }
    }

    onMounted(async () => {
      if (!process.server && route.query.utb_path) {
        LoadingEventBus.show()
        shouldDisplay.value = true
        utbPath.value = (decodeURIComponent(`${route.query.utb_path}`))

        await router.push({
          query: { ...route.query, utb_path: undefined, utb_lang: undefined },
        })

        tryToLoadIFrame()
      }
    })

    return {
      shouldDisplay,
      frameID,
      frameIDLoaded,
      isAuxIFrameDisplayed
    }
  },
})
</script>

<style lang="scss" scoped>
.confirm-iframe {
  @apply bg-spl-gray-1;
  @apply p-2;
}
</style>
